import { usePartnerId } from '@retailer-platform/dashboard/routing'
import { useCreateHref } from './domain/routing'

export interface GoToAccountCreatePageProps {
  preselectRoleId?: string
}

export const useCreateHrefAccountCreatePage = (props: GoToAccountCreatePageProps = {}) => {
  const partnerId = usePartnerId({ throwOnMissing: false })

  const createAccountRoute = partnerId
    ? 'partner-account-management-create'
    : 'app-admin-account-management-create'

  const href = useCreateHref(createAccountRoute, undefined, {
    preselectRole: props.preselectRoleId,
  })

  return href
}
